module.exports = __webpack_public_path__ + "img/question-back.e8d140a0.jpg";